import { useTheme } from "@mui/material";
import maskUnits from "../../utils/maskUnits";

const DynamicMetricsCards: React.FC<DashCardsOfc> = (props) => {
  const theme = useTheme();
  if (!props || !props.type || props.type !== "cards") {
    return <>Configurações Inválidas</>;
  }

  const color = theme.palette.background.paper;
  const textPrimay = theme.palette.text.primary;
  const textSecondary = theme.palette.text.secondary;

  const dataValues = Object.values(props.config.data?.[0] || {});

  const html = props.config.keys
    ? props.config.keys.reduce((acc, key, index) => {
        const value = props.config.units
          ? maskUnits(
              dataValues[index],
              props.config.units,
              props.config.fractionDigits
            )
          : dataValues[index] ?? "";

        return acc
          ?.replaceAll(`{${key}}`, value.toString())
          .replace("{color}", color)
          .replace("{textPrimary}", textPrimay)
          .replace("{textSecondary}", textSecondary);
      }, props.html)
    : "";

  return (
    <div
      style={{ width: "100%", height: "100%" }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default DynamicMetricsCards;
